import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { WizardButton } from '../WizardButton/WizardButton'
import { ADS_CARD_OVERRIDES, ADS_CHANNELS } from '../constants'
import { WizardListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Ads = (props: SectionProps) => {
  const { isMobile } = useResponsiveDesign()
  const wizardsHeading = 'Ad creation wizards'

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardListItemContainer wizards={ADS_CHANNELS} heading={wizardsHeading} withDoc {...props} />
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <Heading level={3}>Which platform you need ad copy for?</Heading>
      <div className={Styles.wizardGroup}>
        {ADS_CHANNELS.map((channelKey) => (
          <WizardButton
            key={channelKey}
            channelKey={channelKey}
            size="md"
            version={2}
            {...props}
            cardInfoOverride={ADS_CARD_OVERRIDES}
          />
        ))}
      </div>
    </div>
  )
}
